(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/theme/assets/javascripts/theme.js') >= 0) return;  svs.modules.push('/components/sport/theme/assets/javascripts/theme.js'); 
'use strict';

(function(svs) {
  svs.sport = svs.sport || {};

  svs.sport.themeLoader = function(options) {
    var self = this;
    this.options = options;
    this.mapping = null;
    this.load = function(callback, templateName) {
      self.templateName = templateName.replace(/-/g, '_');
      self.callback = callback;
      if (self.loadMapping()) {
        self.checkTemplate('team', function(template, init) {
          if (template) {
            self.callback(template, init);
          } else {
            self.checkTemplate('league', function(template, init) {
              if (template) {
                self.callback(template, init);
              } else {
                self.checkTemplate('sport', function(template, init) {
                  self.callback(template, init);
                });
              }
            });
          }
        });
      } else {
        callback();
      }
    };

    this.themeFunction = function(functionName, params) {
      var value;

      self.load(function(template, init) {
        if (init) {
          value = init(functionName, params);
        }
      }, 'init');

      return value;
    };

    this.retrieveSportById = function(sportId) {
      var mapping = null;

      if (_isObject(svs.sport.theme.data.mapping)) {
        mapping = svs.sport.theme.data.mapping;
        if ((mapping || {}).sport) {
          if (mapping.sport[sportId]) return mapping.sport[sportId];
        }
      }
      return null;
    };

    this.exist = function(templateNames) {
      var returner = false;
      templateNames.forEach(function(name) {
        self.templateName = name.replace(/-/g, '_');
        if (self.loadMapping()) {
          if (
            self.checkTemplate('team') ||
            self.checkTemplate('league') ||
            self.checkTemplate('sport')
          ) {
            returner = true;
          }
        }
      });
      return returner;
    };

    this.checkTemplate = function(param, callback) {
      var template = null,
        init = null,
        component = '';
      if (!_isFunction(callback)) {
        callback = function() {};
      }

      if (
        self.options[param] &&
        self.mapping[param] &&
        self.mapping[param][self.options[param]]
      ) {
        component = self.mapping[param][options[param]].replace(/-/g, '_');
        if (_isObject(svs.themes[component].templates[self.templateName])) {
          template = svs.themes[component].templates[self.templateName];
          if (svs.themes[component].init) {
            init = svs.themes[component].init;
          }
          callback(template, init);
          return true;
        }
        callback(false, svs.themes.sportDefault.init);
        return false;
      }
      callback(false, svs.themes.sportDefault.init);
      return false;
    };

    this.loadMapping = function() {
      if (_isObject(svs.sport.theme)) {
        if (_isObject(svs.sport.theme.data.mapping)) {
          self.mapping = svs.sport.theme.data.mapping;
          return true;
        }
      }
      return false;
    };

    function _isObject(obj) {
      var type = typeof obj;
      return type === 'function' || (type === 'object' && !!obj);
    }

    function _isFunction(fun) {
      return typeof fun === 'function';
    }

    return {
      load: this.load,
      exist: this.exist,
      retrieveSportById: this.retrieveSportById,
      themeFunction: this.themeFunction
    };
  };

  if (typeof window === 'undefined') {
    module.exports = svs.sport.themeLoader;
  }
})(svs);

 })(window);